
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("1mAy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $0fe432327d4a2d7e$var$_swiper = $0fe432327d4a2d7e$var$_interopRequireDefault((parcelRequire("2mpqL")));

var $5PBbn = parcelRequire("5PBbn");
function $0fe432327d4a2d7e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $0fe432327d4a2d7e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0fe432327d4a2d7e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0fe432327d4a2d7e$var$_typeof(o);
}
function $0fe432327d4a2d7e$var$_defineProperty(e, r, t) {
    return (r = $0fe432327d4a2d7e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0fe432327d4a2d7e$var$_toPropertyKey(t) {
    var i = $0fe432327d4a2d7e$var$_toPrimitive(t, "string");
    return "symbol" == $0fe432327d4a2d7e$var$_typeof(i) ? i : i + "";
}
function $0fe432327d4a2d7e$var$_toPrimitive(t, r) {
    if ("object" != $0fe432327d4a2d7e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0fe432327d4a2d7e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} // ====================================================================================
// swiper.module
// ====================================================================================
// Pagination, Scrollbar
var $0fe432327d4a2d7e$var$init = module.exports.init = function init() {
    var swiperContainers = document.querySelectorAll(".swiper-container--2");
    swiperContainers.forEach(function(slider) {
        var cID = slider.getAttribute("id");
        var slidesLength = slider.querySelectorAll(".swiper-slide").length;
        var swiper = new $0fe432327d4a2d7e$var$_swiper["default"]("#".concat(cID), $0fe432327d4a2d7e$var$_defineProperty($0fe432327d4a2d7e$var$_defineProperty({
            modules: [
                $5PBbn.Navigation,
                $5PBbn.Pagination,
                $5PBbn.Keyboard,
                $5PBbn.A11y
            ],
            lazy: true,
            loop: true,
            speed: 500,
            slidesPerView: 1,
            enabled: slidesLength > 1 ? true : false,
            pagination: {
                el: "#".concat(cID, " .swiper-pagination"),
                clickable: true,
                renderBullet: function renderBullet(index, className) {
                    return '<span class="'.concat(className, ' dot">').concat(index, "</span>");
                }
            },
            a11y: {
                prevSlideMessage: "Vorherige Folie",
                nextSlideMessage: "N\xe4chste Folie"
            },
            navigation: {
                prevEl: "#".concat(cID, " .swiper-button-prev"),
                nextEl: "#".concat(cID, " .swiper-button-next")
            },
            keyboard: {
                enabled: true
            }
        }, "a11y", {
            enabled: true
        }), "on", {
            afterInit: function afterInit(swiper) {
                document.querySelector("#".concat(cID)).classList.add("slider-init");
                if (swiper.enabled) document.querySelector("#".concat(cID)).classList.remove("slider-lock");
                else document.querySelector("#".concat(cID)).classList.add("slider-lock");
                swiper.updateSize();
                swiper.updateSlides();
            },
            lock: function lock() {
                document.querySelector("#".concat(cID)).classList.add("slider-lock");
            },
            unlock: function unlock() {
                document.querySelector("#".concat(cID)).classList.remove("slider-lock");
            },
            beforeSlideChangeStart: function beforeSlideChangeStart(swiper) {
                var slide = swiper.slides[swiper.activeIndex];
                var tooltips = slide.querySelectorAll('[data-bs-toggle="tooltip"].open');
                tooltips.forEach(function(tooltip) {
                    tooltip.click();
                });
            }
        }));
        swiper.updateSize();
        swiper.updateSlides();
    });
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$71511d61b312f219; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d624443cd99befe$export$71511d61b312f219; });
function $3d624443cd99befe$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$71511d61b312f219; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=swiper2.module.102b6e39.js.map
